export const LogoutActionTypes = {
    OPEN_LOGOUT_PAGE: 'OPEN_LOGOUT_PAGE',
    CLOSE_LOGOUT_PAGE: 'CLOSE_LOGOUT_PAGE',
};